module.exports = __webpack_public_path__ + "static/media/tiger.1836bdfb.jpg";